<kor-modal
  [visible]="visible"
  width="400px"
  (visible-changed)="!$event.target.visible ? close.emit() : ''"
>
  <h2>add to collection</h2>
  <br /><br />
  <kor-card class="cta" (click)="editCollectionModalVisible = true">
    <p>create collection</p>
  </kor-card>
  <kor-card
    *ngFor="let collection of collectionsService.collections"
    (click)="selectedCollection = collection.uid"
    [ngClass]="{ active: selectedCollection === collection.uid }"
  >
    <p>{{ collection.name }}</p>
  </kor-card>
  <!-- footer -->
  <kor-button
    slot="footer"
    label="confirm"
    [disabled]="!selectedCollection"
    (click)="handleConfirm()"
  ></kor-button>
</kor-modal>

<!-- create collection modal -->
<app-edit-collection-modal
  *ngIf="editCollectionModalVisible"
  (close)="editCollectionModalVisible = false"
  (save)="collectionsService.setCollection($event)"
></app-edit-collection-modal>
